// This file is auto-generated by @hey-api/openapi-ts

export type UserData = {
  id: number
  email?: string
  firstName: string
  lastName: string
  isOnboarded: boolean
  isFinancialDataProvided: boolean
  isVerified: boolean
  avatar?: string | null
  personalEmail?: string | null
  phone?: string | null
  calendly?: string | null
  advisorsAccess?: Array<number> | null
  roles?: Array<'ADMIN' | 'EMPLOYEE' | 'EMPLOYER' | 'ADVISOR'>
  appointmentsCount?: number
  bio?: string | null
}

export type EditProfileDTO = {
  firstName: string
  lastName: string
  personalEmail?: string | null
  phoneNumber?: string | null
  avatar?: string | null
  bio?: string | null
}

export type ChangePasswordDTO = {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export type CommonResponse = {
  message: string
  statusCode: number
}

export type MessageData = {
  content: string
  id: number
  recipientId: number
  time: string
  userId: number
}

export type MappedTransaction = {
  id: number
  amount: number
  category:
    | 'HOUSING'
    | 'TRANSPORTATION'
    | 'MEDICAL'
    | 'FOOD'
    | 'ENTERTAINMENT'
    | 'FINANCIAL'
    | 'GIVING'
    | 'OTHER'
    | 'UNKNOWN'
  date: string
  datetime?: string | null
  logo?: string | null
  merchant?: string | null
  name: string
  plaidCategory?: string
  plaidId: string
  excluded: boolean
  accountName: string
  accountMask: string
}

export enum category {
  HOUSING = 'HOUSING',
  TRANSPORTATION = 'TRANSPORTATION',
  MEDICAL = 'MEDICAL',
  FOOD = 'FOOD',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FINANCIAL = 'FINANCIAL',
  GIVING = 'GIVING',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}

export type EditTransactionDTO = {
  category?:
    | 'HOUSING'
    | 'TRANSPORTATION'
    | 'MEDICAL'
    | 'FOOD'
    | 'ENTERTAINMENT'
    | 'FINANCIAL'
    | 'GIVING'
    | 'OTHER'
    | 'UNKNOWN'
  name: string
}

export type EditedTransaction = {
  transaction: MappedTransaction
  otherTransactions: Array<number>
}

export type BulkEditTransactionsDTO = {
  ids: Array<number>
  category:
    | 'HOUSING'
    | 'TRANSPORTATION'
    | 'MEDICAL'
    | 'FOOD'
    | 'ENTERTAINMENT'
    | 'FINANCIAL'
    | 'GIVING'
    | 'OTHER'
    | 'UNKNOWN'
  name: string
}

export type CreateLinkTokenDTO = {
  products: Array<
    | 'assets'
    | 'auth'
    | 'balance'
    | 'balance_plus'
    | 'beacon'
    | 'identity'
    | 'identity_match'
    | 'investments'
    | 'investments_auth'
    | 'liabilities'
    | 'payment_initiation'
    | 'identity_verification'
    | 'transactions'
    | 'credit_details'
    | 'income'
    | 'income_verification'
    | 'deposit_switch'
    | 'standing_orders'
    | 'transfer'
    | 'employment'
    | 'recurring_transactions'
    | 'signal'
    | 'statements'
    | 'processor_payments'
    | 'processor_identity'
    | 'profile'
    | 'cra_base_report'
    | 'cra_income_insights'
    | 'cra_partner_insights'
    | 'layer'
  >
}

export type LinkTokenData = {
  token: string
}

export type PlaidAccount = {
  id: string
  name: string
  mask: string | null
  type: string
  subtype: string
}

export type StoreBankAccountDTO = {
  accessToken: string
  institutionName: string
  institutionId: string
  accounts: Array<PlaidAccount>
}

export type InstitutionData = {
  name: string | null
  plaidId: string | null
}

export type AccountBalanceData = {
  available: number
  current: number
  currency: string
  isBalanceReady?: boolean
}

export type AccountData = {
  name: string
  type: string
  mask: string
  subtype: string
  plaidId: string
  institution: InstitutionData
  balance: AccountBalanceData
  logo?: string
  isManual?: boolean
}

export type CreateAccountsData = {
  accounts: Array<AccountData>
  createdAccounts: number
  skippedAccounts: number
}

export type ManualAccountValueChangeDTO = {
  id?: string
  date: string
  value: number
}

export type StoreManualAccountDTO = {
  name: string
  institution?: string
  balance: number
  balanceDate?: string
  type:
    | 'REAL_ESTATE_PROPERTY'
    | 'VEHICLE'
    | 'PERSONAL_VALUABLES'
    | 'BUSINESS_OWNERSHIP'
    | 'PERSONAL_LOAN'
    | 'AUTO_LOAN'
    | 'OTHER_ASSET'
    | 'OTHER_LIABILITY'
  otherType?: string
  initialValue?: number | null
  initialValueDate?: string
  valueChanged: boolean
  valueChanges?: Array<ManualAccountValueChangeDTO>
  estimationMethod?:
    | 'APPRAISAL'
    | 'MARKET_ESTIMATE'
    | 'SELF_EVALUATION'
    | 'TAX_ASSESSMENT'
    | 'PURCHASE_PRICE'
    | 'OTHER'
  otherEstimationMethod?: string
  notes?: string
  includedInNetWorth: boolean
}

export enum type {
  REAL_ESTATE_PROPERTY = 'REAL_ESTATE_PROPERTY',
  VEHICLE = 'VEHICLE',
  PERSONAL_VALUABLES = 'PERSONAL_VALUABLES',
  BUSINESS_OWNERSHIP = 'BUSINESS_OWNERSHIP',
  PERSONAL_LOAN = 'PERSONAL_LOAN',
  AUTO_LOAN = 'AUTO_LOAN',
  OTHER_ASSET = 'OTHER_ASSET',
  OTHER_LIABILITY = 'OTHER_LIABILITY',
}

export enum estimationMethod {
  APPRAISAL = 'APPRAISAL',
  MARKET_ESTIMATE = 'MARKET_ESTIMATE',
  SELF_EVALUATION = 'SELF_EVALUATION',
  TAX_ASSESSMENT = 'TAX_ASSESSMENT',
  PURCHASE_PRICE = 'PURCHASE_PRICE',
  OTHER = 'OTHER',
}

export type AccountValueChange = {
  date: string
  value: number
}

export type ManualAccountData = {
  id: number
  name: string
  institution?: string
  balance: number
  balanceDate?: string
  type:
    | 'REAL_ESTATE_PROPERTY'
    | 'VEHICLE'
    | 'PERSONAL_VALUABLES'
    | 'BUSINESS_OWNERSHIP'
    | 'PERSONAL_LOAN'
    | 'AUTO_LOAN'
    | 'OTHER_ASSET'
    | 'OTHER_LIABILITY'
  otherType?: string
  initialValue?: number | null
  initialValueDate?: string
  valueChanged: boolean
  valueChanges?: Array<AccountValueChange>
  estimationMethod?:
    | 'APPRAISAL'
    | 'MARKET_ESTIMATE'
    | 'SELF_EVALUATION'
    | 'TAX_ASSESSMENT'
    | 'PURCHASE_PRICE'
    | 'OTHER'
  otherEstimationMethod?: string
  notes?: string
  includedInNetWorth: boolean
}

export type GetAccounts = {
  accounts: Array<AccountData>
}

export type GetLinearStatsData = {
  balance: number
  date: string
}

export type GetDonutStatsData = {
  color: string
  name: string
  value: number
  accounts: Array<string>
}

export type GetIncomeStatsData = {
  value: number
  count: number
}

export type GetSpendingStatsData = {
  value: number
  count: number
}

export type CreateGoalDTO = {
  name: string
  amount: number
  startDate: string
  dueDate: string
  monthlyReminder: boolean
  monthlyReminderAmount?: number
}

export type GoalData = {
  id: number
  name: string
  amount: number
  collectedAmount: number
  startDate: string
  dueDate: string
  monthlyReminder: boolean
  monthlyReminderAmount?: number
  status: 'ACTIVE' | 'COMPLETED' | 'ARCHIVED'
  completedAt?: string
}

export enum status {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
}

export type GoalRecommendationData = {
  id: number
  name: string
  amount: number
  dueDate: string
  status: 'PENDING' | 'ACCEPTED' | 'REJECTED'
  userId: number
  advisorId: number
}

export enum status2 {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type ClaimGoalAmountDTO = {
  amount: number
  note?: string
  goalStepId?: number
}

export type GoalsSavedValue = {
  savedValue: number
}

export type GoalStepData = {
  id: number
  title: string
  targetAmount?: number
  targetDate?: string
  completed: boolean
  completedAt?: string
  sortOrder: number
  createdAt: string
  updatedAt: string
}

export type CreateGoalStepDTO = {
  title: string
  targetAmount?: number
  targetDate?: string
}

export type UpdateGoalStepDTO = {
  title?: string
  targetAmount?: number
  targetDate?: string
}

export type ReorderGoalStepsDTO = {
  stepIds: Array<number>
}

export type NotificationParams = {
  action: 'CLAIM_MONTHLY_REMINDER'
  param: string
}

export enum action {
  CLAIM_MONTHLY_REMINDER = 'CLAIM_MONTHLY_REMINDER',
}

export type NotificationData = {
  id: number
  title: string
  body: string
  params: NotificationParams
  status: 'UNREAD' | 'READ'
}

export enum status3 {
  UNREAD = 'UNREAD',
  READ = 'READ',
}

export type GetPresignedURLDTO = {
  filename: string
}

export type GetSignedURLResponse = {
  url: string
  key: string
}

export type CreateBudgetDTO = {
  monthlyAmount: number
  category:
    | 'HOUSING'
    | 'TRANSPORTATION'
    | 'MEDICAL'
    | 'FOOD'
    | 'ENTERTAINMENT'
    | 'FINANCIAL'
    | 'GIVING'
    | 'OTHER'
    | 'UNKNOWN'
}

export type BudgetData = {
  id: number
  category:
    | 'HOUSING'
    | 'TRANSPORTATION'
    | 'MEDICAL'
    | 'FOOD'
    | 'ENTERTAINMENT'
    | 'FINANCIAL'
    | 'GIVING'
    | 'OTHER'
    | 'UNKNOWN'
  monthlyAmount: number
}

export type BudgetDataWithAmounts = {
  id: number
  category:
    | 'HOUSING'
    | 'TRANSPORTATION'
    | 'MEDICAL'
    | 'FOOD'
    | 'ENTERTAINMENT'
    | 'FINANCIAL'
    | 'GIVING'
    | 'OTHER'
    | 'UNKNOWN'
  monthlyAmount: number
  spent: number
  remaining: number
}

export type BudgetStats = {
  budgets: Array<BudgetDataWithAmounts>
  totalSpend: number
  totalBudget: number
  totalIncome: number
}

export type CreateUserDTO = {
  firstName: string
  lastName: string
  email: string
  password: string
  confirmPassword: string
  agreeToTerms: boolean
  agreeToPrivacyPolicy: boolean
}

export type UserLoginDTO = {
  email: string
  password: string
}

export type CreateResetPasswordTokenDTO = {
  email: string
}

export type VerifyEmailDTO = {
  token: string
  email: string
}

export type BadRequestErrorResponseMessage = {
  error: string
  field: string
}

export type BadRequestErrorResponse = {
  message: Array<BadRequestErrorResponseMessage>
  error: string
  statusCode: number
}

export type CommonErrorResponse = {
  message: string
  statusCode: number
  error: string
}

export type ResetPasswordDTO = {
  email: string
  password: string
  confirmPassword: string
  token: string
}

export type Answer = {
  question: string
  answer: string
  fieldName: string
  isFinancial: boolean
  isRaceField?: boolean
  isBirthDate?: boolean
  isGenderField?: boolean
  isIncomeField?: boolean
  isHidden?: boolean
}

export type OnboardingDTO = {
  /**
   * Must be a valid JSON object with the following structure: [{ question: string, answer: string, isFinancial: boolean }].
   */
  answers: Array<Answer>
}

export type OnboardingAnswers = {
  answers: Array<Answer>
}

export type AdvisorData = {
  id: number
  firstName: string
  lastName: string
  calendly: string
  avatar: string | null
  bio: string | null
}

export type GrantAdvisorAccessDto = {
  advisor: number
}

export type FinancialAnswer = {
  answer: string
  question: string
  isBirthDate?: boolean
}

export type CreateGoalRecommendationDTO = {
  name: string
  amount: number
  dueDate: string
}

export type AdvisorAppointmentData = {
  date?: string | null
  id: number
  topic?: string | null
  status: 'PENDING' | 'SCHEDULED' | 'CANCELLED'
  user: UserData
}

export enum status4 {
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  CANCELLED = 'CANCELLED',
}

export type UserStatsCounter = {
  count: number
}

export type StatsCounter = {
  stats: {
    [key: string]: unknown
  }
}

export type CompanyData = {
  domain: string
  id: number
  name: string
}

export type BulkWhitelistEmailsDTO = {
  emails: Array<string>
}

export type VerifyUserAdminDTO = {
  email: string
}

export type ChangeUserRoleDTO = {
  role: 'ADMIN' | 'EMPLOYEE' | 'EMPLOYER' | 'ADVISOR'
}

export enum role {
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYER = 'EMPLOYER',
  ADVISOR = 'ADVISOR',
}

export type InsightItem = {
  ruleId: string
  page: 'ACTION_PLAN' | 'BUDGET' | 'NET_WORTH' | 'DASHBOARD'
  ruleClass: 'OBSERVATIONAL' | 'POSITIVE' | 'MICRO_SUGGESTION'
  severity: 'INFO' | 'WARNING'
  title: string
  body: string
  cooldownDays: number
  dedupeKey: string
  explainability: Array<string>
  metrics?: {
    [key: string]: unknown
  }
}

export enum page {
  ACTION_PLAN = 'ACTION_PLAN',
  BUDGET = 'BUDGET',
  NET_WORTH = 'NET_WORTH',
  DASHBOARD = 'DASHBOARD',
}

export enum ruleClass {
  OBSERVATIONAL = 'OBSERVATIONAL',
  POSITIVE = 'POSITIVE',
  MICRO_SUGGESTION = 'MICRO_SUGGESTION',
}

export enum severity {
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export type InsightsResponse = {
  page: 'ACTION_PLAN' | 'BUDGET' | 'NET_WORTH' | 'DASHBOARD'
  selectionDate: string
  insights: Array<InsightItem>
}

export type CreateAppointmentDTO = {
  advisorId: number
  calendlyId: string
}

export type AppointmentData = {
  date?: string | null
  id: number
  topic?: string | null
  status: 'PENDING' | 'SCHEDULED' | 'CANCELLED'
  advisor: AdvisorData
}

export type SupportSearchResultItem = {
  type: 'account' | 'transaction'
  id: number
  label: string
  secondary?: string | null
}

export enum type2 {
  ACCOUNT = 'account',
  TRANSACTION = 'transaction',
}

export type SupportSearchResponse = {
  results: Array<SupportSearchResultItem>
}

export type CreateSupportTicketDTO = {
  subject: string
  message: string
  accountId?: number
  transactionId?: number
}

export type UserControllerGetLoggedUserResponse = UserData

export type UserControllerDeleteUserResponse = CommonResponse

export type UserControllerEditProfileData = {
  requestBody: EditProfileDTO
}

export type UserControllerEditProfileResponse = UserData

export type UserControllerChangePasswordData = {
  requestBody: ChangePasswordDTO
}

export type UserControllerChangePasswordResponse = UserData

export type MessageControllerGetAllMessagesData = {
  recipientId: number
  skip: number
  take: number
}

export type MessageControllerGetAllMessagesResponse = Array<MessageData>

export type MessageControllerMarkThreadReadData = {
  recipientId: number
}

export type MessageControllerMarkThreadReadResponse = unknown

export type QueueControllerProcessJobsResponse = unknown

export type QueueControllerSyncTransactionsResponse = unknown

export type QueueControllerMonthlyJobsResponse = unknown

export type TransactionControllerGetTransactionsData = {
  endDate: string
  startDate: string
  type: 'income' | 'spending'
}

export type TransactionControllerGetTransactionsResponse =
  Array<MappedTransaction>

export type TransactionControllerBulkEditTransactionsData = {
  requestBody: BulkEditTransactionsDTO
}

export type TransactionControllerBulkEditTransactionsResponse =
  Array<MappedTransaction>

export type TransactionControllerToggleExcludedData = {
  transactionId: number
}

export type TransactionControllerToggleExcludedResponse = MappedTransaction

export type TransactionControllerEditTransactionData = {
  requestBody: EditTransactionDTO
  transactionId: number
}

export type TransactionControllerEditTransactionResponse = EditedTransaction

export type BankingControllerCreateLinkTokenData = {
  requestBody: CreateLinkTokenDTO
}

export type BankingControllerCreateLinkTokenResponse = LinkTokenData

export type BankingControllerCreateAccountsData = {
  requestBody: StoreBankAccountDTO
}

export type BankingControllerCreateAccountsResponse = CreateAccountsData

export type BankingControllerCreateManualAccountData = {
  requestBody: StoreManualAccountDTO
}

export type BankingControllerCreateManualAccountResponse = ManualAccountData

export type BankingControllerEditManualAccountData = {
  accountId: string
  requestBody: StoreManualAccountDTO
}

export type BankingControllerEditManualAccountResponse = ManualAccountData

export type BankingControllerDeleteManualAccountData = {
  accountId: string
}

export type BankingControllerDeleteManualAccountResponse = ManualAccountData

export type BankingControllerGetManualAccountData = {
  accountId: string
}

export type BankingControllerGetManualAccountResponse = ManualAccountData

export type BankingControllerGetAccountsResponse = GetAccounts

export type BankingControllerGetManualAccountsResponse =
  Array<ManualAccountData>

export type BankingControllerDeleteAccountData = {
  accountId: string
}

export type BankingControllerDeleteAccountResponse = AccountData

export type BankingControllerWebhookResponse = unknown

export type BankingControllerGetLinearStatsData = {
  period: 'half-year' | 'month' | 'quarter' | 'year'
  type: 'assets' | 'debt' | 'net-worth'
}

export type BankingControllerGetLinearStatsResponse = Array<GetLinearStatsData>

export type BankingControllerGetDonutStatsData = {
  type: 'assets' | 'debt' | 'net-worth'
}

export type BankingControllerGetDonutStatsResponse = Array<GetDonutStatsData>

export type BankingControllerGetIncomeStatsData = {
  endDate: string
  startDate: string
}

export type BankingControllerGetIncomeStatsResponse = GetIncomeStatsData

export type BankingControllerGetSpendingStatsData = {
  endDate: string
  startDate: string
}

export type BankingControllerGetSpendingStatsResponse = GetSpendingStatsData

export type GoalsControllerAddData = {
  requestBody: CreateGoalDTO
}

export type GoalsControllerAddResponse = GoalData

export type GoalsControllerUpdateData = {
  goalId: number
  requestBody: CreateGoalDTO
}

export type GoalsControllerUpdateResponse = GoalData

export type GoalsControllerDeleteData = {
  goalId: number
}

export type GoalsControllerDeleteResponse = void

export type GoalsControllerGetData = {
  goalId: number
}

export type GoalsControllerGetResponse = GoalData

export type GoalsControllerGetAllData = {
  orderBy: 'deadline' | 'new_first' | 'old_first'
  status?: 'ACTIVE' | 'COMPLETED' | 'ARCHIVED'
}

export type GoalsControllerGetAllResponse = Array<GoalData>

export type GoalsControllerGetRecommendationsResponse =
  Array<GoalRecommendationData>

export type GoalsControllerAcceptRecommendationData = {
  recommendationId: number
}

export type GoalsControllerAcceptRecommendationResponse = GoalData

export type GoalsControllerRejectRecommendationData = {
  recommendationId: number
}

export type GoalsControllerRejectRecommendationResponse = void

export type GoalsControllerClaimAmountData = {
  goalId: number
  requestBody: ClaimGoalAmountDTO
}

export type GoalsControllerClaimAmountResponse = GoalData

export type GoalsControllerGetSavedValueData = {
  endDate: string
  startDate: string
}

export type GoalsControllerGetSavedValueResponse = GoalsSavedValue

export type GoalsControllerCompleteData = {
  goalId: number
}

export type GoalsControllerCompleteResponse = GoalData

export type GoalsControllerArchiveData = {
  goalId: number
}

export type GoalsControllerArchiveResponse = GoalData

export type GoalsControllerReactivateData = {
  goalId: number
}

export type GoalsControllerReactivateResponse = GoalData

export type GoalsControllerGetStepsData = {
  goalId: number
}

export type GoalsControllerGetStepsResponse = Array<GoalStepData>

export type GoalsControllerAddStepData = {
  goalId: number
  requestBody: CreateGoalStepDTO
}

export type GoalsControllerAddStepResponse = GoalStepData

export type GoalsControllerUpdateStepData = {
  goalId: number
  requestBody: UpdateGoalStepDTO
  stepId: number
}

export type GoalsControllerUpdateStepResponse = GoalStepData

export type GoalsControllerDeleteStepData = {
  goalId: number
  stepId: number
}

export type GoalsControllerDeleteStepResponse = void

export type GoalsControllerToggleStepData = {
  goalId: number
  stepId: number
}

export type GoalsControllerToggleStepResponse = GoalStepData

export type GoalsControllerReorderStepsData = {
  goalId: number
  requestBody: ReorderGoalStepsDTO
}

export type GoalsControllerReorderStepsResponse = void

export type NotificationControllerGetAllData = {
  action?: 'CLAIM_MONTHLY_REMINDER'
  status?: 'UNREAD' | 'READ'
}

export type NotificationControllerGetAllResponse = Array<NotificationData>

export type NotificationControllerMarkAsReadData = {
  notificationId: number
}

export type NotificationControllerMarkAsReadResponse = NotificationData

export type FileControllerGetPresignedUrlData = {
  requestBody: GetPresignedURLDTO
}

export type FileControllerGetPresignedUrlResponse = GetSignedURLResponse

export type FileControllerGetSignedUrlData = {
  filename: string
}

export type FileControllerGetSignedUrlResponse = string

export type BudgetControllerAddBudgetData = {
  requestBody: CreateBudgetDTO
}

export type BudgetControllerAddBudgetResponse = BudgetData

export type BudgetControllerUpdateBudgetData = {
  budgetId: number
  requestBody: CreateBudgetDTO
}

export type BudgetControllerUpdateBudgetResponse = BudgetData

export type BudgetControllerDeleteBudgetData = {
  budgetId: number
}

export type BudgetControllerDeleteBudgetResponse = void

export type BudgetControllerGetBudgetData = {
  budgetId: number
}

export type BudgetControllerGetBudgetResponse = BudgetData

export type BudgetControllerGetAllBudgetsData = {
  endDate: string
  startDate: string
}

export type BudgetControllerGetAllBudgetsResponse = BudgetStats

export type AuthControllerRegisterData = {
  requestBody: CreateUserDTO
}

export type AuthControllerRegisterResponse = UserData

export type AuthControllerLoginData = {
  requestBody: UserLoginDTO
}

export type AuthControllerLoginResponse = UserData

export type AuthControllerLogoutResponse = CommonResponse

export type AuthControllerResetPasswordData = {
  requestBody: CreateResetPasswordTokenDTO
}

export type AuthControllerResetPasswordResponse = CommonResponse

export type VerifyControllerVerifyEmailData = {
  requestBody: VerifyEmailDTO
}

export type VerifyControllerVerifyEmailResponse = CommonResponse

export type VerifyControllerVerifyResetPasswordTokenData = {
  requestBody: ResetPasswordDTO
}

export type VerifyControllerVerifyResetPasswordTokenResponse = CommonResponse

export type OnboardingControllerOnboardingData = {
  requestBody: OnboardingDTO
}

export type OnboardingControllerOnboardingResponse = UserData

export type OnboardingControllerGetAnswersResponse = OnboardingAnswers

export type OnboardingControllerUpdateAnswersData = {
  requestBody: OnboardingDTO
}

export type OnboardingControllerUpdateAnswersResponse = UserData

export type AdvisorControllerGetAllAdvisorsData = {
  query?: string
}

export type AdvisorControllerGetAllAdvisorsResponse = Array<AdvisorData>

export type AdvisorControllerGrantAccessData = {
  requestBody: GrantAdvisorAccessDto
}

export type AdvisorControllerGrantAccessResponse = UserData

export type AdvisorControllerRevokeAccessData = {
  requestBody: GrantAdvisorAccessDto
}

export type AdvisorControllerRevokeAccessResponse = UserData

export type AdvisorUsersControllerGetUsersResponse = Array<UserData>

export type AdvisorUsersControllerGetUserByIdData = {
  userId: number
}

export type AdvisorUsersControllerGetUserByIdResponse = UserData

export type AdvisorUsersControllerGetChatUsersData = {
  query?: string
}

export type AdvisorUsersControllerGetChatUsersResponse = Array<UserData>

export type AdvisorUsersControllerGetUserQuestionnaireData = {
  userId: number
}

export type AdvisorUsersControllerGetUserQuestionnaireResponse =
  Array<FinancialAnswer>

export type AdvisorUsersControllerGetDonutStatsData = {
  type: 'assets' | 'debt' | 'net-worth'
  userId: number
}

export type AdvisorUsersControllerGetDonutStatsResponse =
  Array<GetDonutStatsData>

export type AdvisorUsersControllerGetIncomeStatsData = {
  endDate: string
  startDate: string
  userId: number
}

export type AdvisorUsersControllerGetIncomeStatsResponse = GetIncomeStatsData

export type AdvisorUsersControllerGetSpendingStatsData = {
  endDate: string
  startDate: string
  userId: number
}

export type AdvisorUsersControllerGetSpendingStatsResponse =
  GetSpendingStatsData

export type AdvisorUsersControllerGetLinearStatsData = {
  period: 'half-year' | 'month' | 'quarter' | 'year'
  type: 'assets' | 'debt' | 'net-worth'
  userId: number
}

export type AdvisorUsersControllerGetLinearStatsResponse =
  Array<GetLinearStatsData>

export type AdvisorUsersControllerGetBudgetsData = {
  endDate: string
  startDate: string
  userId: number
}

export type AdvisorUsersControllerGetBudgetsResponse = BudgetStats

export type AdvisorUsersControllerGetGoalsData = {
  userId: number
}

export type AdvisorUsersControllerGetGoalsResponse = Array<GoalData>

export type AdvisorUsersControllerGetAccountsData = {
  userId: number
}

export type AdvisorUsersControllerGetAccountsResponse = GetAccounts

export type AdvisorUsersControllerGetTransactionsData = {
  endDate: string
  startDate: string
  type: 'income' | 'spending'
  userId: number
}

export type AdvisorUsersControllerGetTransactionsResponse =
  Array<MappedTransaction>

export type AdvisorGoalsControllerCreateGoalRecommendationData = {
  requestBody: CreateGoalRecommendationDTO
  userId: number
}

export type AdvisorGoalsControllerCreateGoalRecommendationResponse =
  GoalRecommendationData

export type AdvisorAppointmentsControllerGetAllAppointmentsData = {
  limit?: number
  sort?: unknown
  userId?: number
}

export type AdvisorAppointmentsControllerGetAllAppointmentsResponse =
  AdvisorAppointmentData

export type AdminStatsControllerGetUserStatsData = {
  company?: string
  endDate: string
  startDate: string
}

export type AdminStatsControllerGetUserStatsResponse = UserStatsCounter

export type AdminStatsControllerGetGenderStatsData = {
  company?: string
}

export type AdminStatsControllerGetGenderStatsResponse = StatsCounter

export type AdminStatsControllerGetRaceStatsData = {
  company?: string
}

export type AdminStatsControllerGetRaceStatsResponse = StatsCounter

export type AdminStatsControllerGetAgeStatsData = {
  company?: string
}

export type AdminStatsControllerGetAgeStatsResponse = StatsCounter

export type AdminStatsControllerGetIncomeStatsData = {
  company?: string
}

export type AdminStatsControllerGetIncomeStatsResponse = StatsCounter

export type AdminStatsControllerGetTopicsStatsData = {
  company?: string
}

export type AdminStatsControllerGetTopicsStatsResponse = StatsCounter

export type AdminCompaniesControllerGetCompaniesResponse = Array<CompanyData>

export type AdminWhitelistControllerAddWhitelistedEmailsData = {
  requestBody: BulkWhitelistEmailsDTO
}

export type AdminWhitelistControllerAddWhitelistedEmailsResponse = unknown

export type AdminWhitelistControllerDeleteWhitelistedEmailsData = {
  requestBody: BulkWhitelistEmailsDTO
}

export type AdminWhitelistControllerDeleteWhitelistedEmailsResponse = unknown

export type AdminUsersControllerVerifyUserData = {
  requestBody: VerifyUserAdminDTO
}

export type AdminUsersControllerVerifyUserResponse = CommonResponse

export type EmployerStatsControllerGetUserStatsData = {
  company?: string
  endDate: string
  startDate: string
}

export type EmployerStatsControllerGetUserStatsResponse = UserStatsCounter

export type EmployerStatsControllerGetGenderStatsResponse = StatsCounter

export type EmployerStatsControllerGetRaceStatsResponse = StatsCounter

export type EmployerStatsControllerGetAgeStatsResponse = StatsCounter

export type EmployerStatsControllerGetIncomeStatsResponse = StatsCounter

export type EmployerStatsControllerGetTopicStatsResponse = StatsCounter

export type EmployerUsersControllerGetAllEmployeesResponse = Array<UserData>

export type EmployerUsersControllerDeleteEmployeeData = {
  userId: number
}

export type EmployerUsersControllerDeleteEmployeeResponse = void

export type EmployerUsersControllerChangeRoleData = {
  requestBody: ChangeUserRoleDTO
  userId: number
}

export type EmployerUsersControllerChangeRoleResponse = UserData

export type EmployerAdvisorControllerGetAllAdvisorsResponse = Array<AdvisorData>

export type InsightsControllerGetInsightsData = {
  /**
   * The page to load insights for
   */
  page: 'ACTION_PLAN' | 'BUDGET' | 'NET_WORTH' | 'DASHBOARD'
}

export type InsightsControllerGetInsightsResponse = InsightsResponse

export type AppointmentsControllerCreateAppointmentData = {
  requestBody: CreateAppointmentDTO
}

export type AppointmentsControllerCreateAppointmentResponse = AppointmentData

export type AppointmentsControllerGetAppointmentsData = {
  limit?: number
  sort?: unknown
  userId?: number
}

export type AppointmentsControllerGetAppointmentsResponse = unknown

export type AppointmentsControllerWebhookResponse = unknown

export type SupportControllerSearchData = {
  query?: string
  type?: 'account' | 'transaction'
}

export type SupportControllerSearchResponse = SupportSearchResponse

export type SupportControllerCreateTicketData = {
  requestBody: CreateSupportTicketDTO
}

export type SupportControllerCreateTicketResponse = void

export type EmailNotificationsControllerEvaluateResponse = unknown

export type EmailNotificationsControllerDispatchResponse = unknown

export type EmailNotificationsControllerBaselineResponse = unknown

export type EmailPreviewControllerSendData = {
  /**
   * Send a single template (e.g. notif.goalCheckIn). Omit to send all.
   */
  key?: string
}

export type EmailPreviewControllerSendResponse = unknown

export type $OpenApiTs = {
  '/user': {
    get: {
      res: {
        /**
         * Returns the logged user
         */
        200: UserData
      }
    }
    delete: {
      res: {
        /**
         * Returns the message that user was deleted successfully
         */
        204: CommonResponse
      }
    }
  }
  '/user/edit': {
    post: {
      req: UserControllerEditProfileData
      res: {
        /**
         * Returns the updated user
         */
        200: UserData
      }
    }
  }
  '/user/password': {
    put: {
      req: UserControllerChangePasswordData
      res: {
        /**
         * Returns the updated user
         */
        201: UserData
      }
    }
  }
  '/messages/{recipientId}': {
    get: {
      req: MessageControllerGetAllMessagesData
      res: {
        /**
         * Get all messages
         */
        200: Array<MessageData>
      }
    }
  }
  '/messages/{recipientId}/read': {
    put: {
      req: MessageControllerMarkThreadReadData
      res: {
        /**
         * Mark a conversation (messages from :recipientId) as read
         */
        200: unknown
      }
    }
  }
  '/queue/process-jobs': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/queue/sync-transactions': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/queue/monthly-jobs': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/transactions': {
    get: {
      req: TransactionControllerGetTransactionsData
      res: {
        /**
         * Transactions fetched successfully
         */
        200: Array<MappedTransaction>
      }
    }
    put: {
      req: TransactionControllerBulkEditTransactionsData
      res: {
        /**
         * Transactions edited successfully
         */
        201: Array<MappedTransaction>
      }
    }
  }
  '/transaction/{transactionId}/toggle-excluded': {
    put: {
      req: TransactionControllerToggleExcludedData
      res: {
        /**
         * Transaction excluded status toggled successfully
         */
        201: MappedTransaction
      }
    }
  }
  '/transaction/{transactionId}': {
    put: {
      req: TransactionControllerEditTransactionData
      res: {
        /**
         * Transaction edited successfully
         */
        201: EditedTransaction
      }
    }
  }
  '/banking/auth': {
    post: {
      req: BankingControllerCreateLinkTokenData
      res: {
        /**
         * Link token created successfully
         */
        201: LinkTokenData
      }
    }
  }
  '/banking/account': {
    post: {
      req: BankingControllerCreateAccountsData
      res: {
        /**
         * Bank accounts created successfully
         */
        201: CreateAccountsData
      }
    }
  }
  '/banking/account/custom': {
    post: {
      req: BankingControllerCreateManualAccountData
      res: {
        /**
         * Manual account created successfully
         */
        201: ManualAccountData
      }
    }
  }
  '/banking/account/custom/{accountId}': {
    put: {
      req: BankingControllerEditManualAccountData
      res: {
        /**
         * Manual account edited successfully
         */
        201: ManualAccountData
      }
    }
    delete: {
      req: BankingControllerDeleteManualAccountData
      res: {
        /**
         * Manual account deleted successfully
         */
        204: ManualAccountData
      }
    }
    get: {
      req: BankingControllerGetManualAccountData
      res: {
        /**
         * Manual account retrieved successfully
         */
        200: ManualAccountData
      }
    }
  }
  '/banking/accounts': {
    get: {
      res: {
        /**
         * Bank accounts retrieved successfully
         */
        200: GetAccounts
      }
    }
  }
  '/banking/accounts/custom': {
    get: {
      res: {
        /**
         * Manual accounts retrieved successfully
         */
        200: Array<ManualAccountData>
      }
    }
  }
  '/banking/account/{accountId}': {
    delete: {
      req: BankingControllerDeleteAccountData
      res: {
        /**
         * Bank account deleted successfully
         */
        204: AccountData
      }
    }
  }
  '/banking/webhook': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/banking/stats/linear': {
    get: {
      req: BankingControllerGetLinearStatsData
      res: {
        /**
         * Linear stats retrieved successfully
         */
        200: Array<GetLinearStatsData>
      }
    }
  }
  '/banking/stats/donut': {
    get: {
      req: BankingControllerGetDonutStatsData
      res: {
        /**
         * Donut stats retrieved successfully
         */
        200: Array<GetDonutStatsData>
      }
    }
  }
  '/banking/stats/income': {
    get: {
      req: BankingControllerGetIncomeStatsData
      res: {
        /**
         * Income stats retrieved successfully
         */
        200: GetIncomeStatsData
      }
    }
  }
  '/banking/stats/spending': {
    get: {
      req: BankingControllerGetSpendingStatsData
      res: {
        /**
         * Spending stats retrieved successfully
         */
        200: GetSpendingStatsData
      }
    }
  }
  '/goal': {
    post: {
      req: GoalsControllerAddData
      res: {
        /**
         * Goal created successfully
         */
        201: GoalData
      }
    }
  }
  '/goal/{goalId}': {
    put: {
      req: GoalsControllerUpdateData
      res: {
        /**
         * Goal updated successfully
         */
        201: GoalData
      }
    }
    delete: {
      req: GoalsControllerDeleteData
      res: {
        /**
         * Goal deleted successfully
         */
        204: void
      }
    }
    get: {
      req: GoalsControllerGetData
      res: {
        /**
         * Goal retrieved successfully
         */
        200: GoalData
      }
    }
  }
  '/goals': {
    get: {
      req: GoalsControllerGetAllData
      res: {
        /**
         * Goals retrieved successfully
         */
        200: Array<GoalData>
      }
    }
  }
  '/goals/recommendations': {
    get: {
      res: {
        /**
         * Recommendations retrieved successfully
         */
        200: Array<GoalRecommendationData>
      }
    }
  }
  '/goals/recommendation/{recommendationId}': {
    put: {
      req: GoalsControllerAcceptRecommendationData
      res: {
        /**
         * Recommendation added successfully
         */
        201: GoalData
      }
    }
    delete: {
      req: GoalsControllerRejectRecommendationData
      res: {
        /**
         * Recommendation rejected successfully
         */
        204: void
      }
    }
  }
  '/goal/{goalId}/claim': {
    post: {
      req: GoalsControllerClaimAmountData
      res: {
        /**
         * Goal claimed successfully
         */
        201: GoalData
      }
    }
  }
  '/goals/saved': {
    get: {
      req: GoalsControllerGetSavedValueData
      res: {
        /**
         * Saved value retrieved successfully
         */
        200: GoalsSavedValue
      }
    }
  }
  '/goal/{goalId}/complete': {
    post: {
      req: GoalsControllerCompleteData
      res: {
        /**
         * Goal completed successfully
         */
        200: GoalData
      }
    }
  }
  '/goal/{goalId}/archive': {
    post: {
      req: GoalsControllerArchiveData
      res: {
        /**
         * Goal archived successfully
         */
        200: GoalData
      }
    }
  }
  '/goal/{goalId}/reactivate': {
    post: {
      req: GoalsControllerReactivateData
      res: {
        /**
         * Goal reactivated successfully
         */
        200: GoalData
      }
    }
  }
  '/goal/{goalId}/steps': {
    get: {
      req: GoalsControllerGetStepsData
      res: {
        /**
         * Steps retrieved successfully
         */
        200: Array<GoalStepData>
      }
    }
    post: {
      req: GoalsControllerAddStepData
      res: {
        /**
         * Step created successfully
         */
        201: GoalStepData
      }
    }
  }
  '/goal/{goalId}/step/{stepId}': {
    put: {
      req: GoalsControllerUpdateStepData
      res: {
        /**
         * Step updated successfully
         */
        200: GoalStepData
      }
    }
    delete: {
      req: GoalsControllerDeleteStepData
      res: {
        /**
         * Step deleted successfully
         */
        204: void
      }
    }
  }
  '/goal/{goalId}/step/{stepId}/toggle': {
    post: {
      req: GoalsControllerToggleStepData
      res: {
        /**
         * Step toggled successfully
         */
        200: GoalStepData
      }
    }
  }
  '/goal/{goalId}/steps/reorder': {
    put: {
      req: GoalsControllerReorderStepsData
      res: {
        /**
         * Steps reordered successfully
         */
        204: void
      }
    }
  }
  '/notifications': {
    get: {
      req: NotificationControllerGetAllData
      res: {
        /**
         * Get all notifications
         */
        200: Array<NotificationData>
      }
    }
  }
  '/notification/read/{notificationId}': {
    put: {
      req: NotificationControllerMarkAsReadData
      res: {
        /**
         * Marked notification as read
         */
        201: NotificationData
      }
    }
  }
  '/file/presigned-url': {
    post: {
      req: FileControllerGetPresignedUrlData
      res: {
        /**
         * Returns a presigned URL for uploading a file
         */
        201: GetSignedURLResponse
      }
    }
  }
  '/file': {
    get: {
      req: FileControllerGetSignedUrlData
      res: {
        /**
         * Returns a signed URL for downloading a file
         */
        200: string
      }
    }
  }
  '/budget': {
    post: {
      req: BudgetControllerAddBudgetData
      res: {
        /**
         * Budget created successfully
         */
        201: BudgetData
      }
    }
  }
  '/budget/{budgetId}': {
    put: {
      req: BudgetControllerUpdateBudgetData
      res: {
        /**
         * Budget updated successfully
         */
        201: BudgetData
      }
    }
    delete: {
      req: BudgetControllerDeleteBudgetData
      res: {
        /**
         * Budget deleted successfully
         */
        204: void
      }
    }
    get: {
      req: BudgetControllerGetBudgetData
      res: {
        /**
         * Budget fetched successfully
         */
        200: BudgetData
      }
    }
  }
  '/budgets': {
    get: {
      req: BudgetControllerGetAllBudgetsData
      res: {
        /**
         * Budgets fetched successfully
         */
        200: BudgetStats
      }
    }
  }
  '/register': {
    post: {
      req: AuthControllerRegisterData
      res: {
        /**
         * Returned created user object
         */
        201: UserData
      }
    }
  }
  '/login': {
    post: {
      req: AuthControllerLoginData
      res: {
        /**
         * Returned logged in user object
         */
        201: UserData
      }
    }
  }
  '/logout': {
    post: {
      res: {
        /**
         * Returned when user is logged out
         */
        200: CommonResponse
      }
    }
  }
  '/reset-password': {
    put: {
      req: AuthControllerResetPasswordData
      res: {
        /**
         * Returned when password reset email is sent. Notice! This response is always successful, even if email does not exist in the database.
         */
        201: CommonResponse
      }
    }
  }
  '/verify/email': {
    put: {
      req: VerifyControllerVerifyEmailData
      res: {
        /**
         * Returned when email is verified successfully
         */
        201: CommonResponse
        /**
         * Returned when validation fails
         */
        400: BadRequestErrorResponse
        /**
         * Returned when email verification token is invalid
         */
        404: CommonErrorResponse
        /**
         * Returned when something went wrong
         */
        500: CommonErrorResponse
      }
    }
  }
  '/verify/reset-password': {
    put: {
      req: VerifyControllerVerifyResetPasswordTokenData
      res: {
        /**
         * Returned when password is changed successfully
         */
        201: CommonResponse
        /**
         * Returned when validation fails
         */
        400: BadRequestErrorResponse
        /**
         * Returned when reset password token is invalid
         */
        404: CommonErrorResponse
        /**
         * Returned when something went wrong
         */
        500: CommonErrorResponse
      }
    }
  }
  '/onboarding': {
    post: {
      req: OnboardingControllerOnboardingData
      res: {
        /**
         * Onboarding answers created successfully
         */
        201: UserData
      }
    }
    get: {
      res: {
        /**
         * Onboarding answers fetched successfully
         */
        200: OnboardingAnswers
      }
    }
    put: {
      req: OnboardingControllerUpdateAnswersData
      res: {
        /**
         * Onboarding answers updated successfully
         */
        201: UserData
      }
    }
  }
  '/advisors': {
    get: {
      req: AdvisorControllerGetAllAdvisorsData
      res: {
        /**
         * Get all advisors
         */
        200: Array<AdvisorData>
      }
    }
  }
  '/advisor/grant-access': {
    post: {
      req: AdvisorControllerGrantAccessData
      res: {
        /**
         * Grant access to advisor
         */
        201: UserData
      }
    }
  }
  '/advisor/revoke-access': {
    post: {
      req: AdvisorControllerRevokeAccessData
      res: {
        /**
         * Revoke access to advisor
         */
        200: UserData
      }
    }
  }
  '/advisors/users': {
    get: {
      res: {
        /**
         * Get users who grant access to the advisor
         */
        200: Array<UserData>
      }
    }
  }
  '/advisors/user/{userId}': {
    get: {
      req: AdvisorUsersControllerGetUserByIdData
      res: {
        /**
         * Get user by id
         */
        200: UserData
      }
    }
  }
  '/advisors/users/chat': {
    get: {
      req: AdvisorUsersControllerGetChatUsersData
      res: {
        /**
         * Get users who already talked to the advisor
         */
        200: Array<UserData>
      }
    }
  }
  '/advisors/user/{userId}/questionnaire': {
    get: {
      req: AdvisorUsersControllerGetUserQuestionnaireData
      res: {
        /**
         * Get user questionnaire
         */
        200: Array<FinancialAnswer>
      }
    }
  }
  '/advisors/user/{userId}/donut-stats': {
    get: {
      req: AdvisorUsersControllerGetDonutStatsData
      res: {
        /**
         * Donut stats retrieved successfully
         */
        200: Array<GetDonutStatsData>
      }
    }
  }
  '/advisors/user/{userId}/income-stats': {
    get: {
      req: AdvisorUsersControllerGetIncomeStatsData
      res: {
        /**
         * Income stats retrieved successfully
         */
        200: GetIncomeStatsData
      }
    }
  }
  '/advisors/user/{userId}/spending-stats': {
    get: {
      req: AdvisorUsersControllerGetSpendingStatsData
      res: {
        /**
         * Spending stats retrieved successfully
         */
        200: GetSpendingStatsData
      }
    }
  }
  '/advisors/user/{userId}/linear-stats': {
    get: {
      req: AdvisorUsersControllerGetLinearStatsData
      res: {
        /**
         * Linear stats retrieved successfully
         */
        200: Array<GetLinearStatsData>
      }
    }
  }
  '/advisors/user/{userId}/budgets': {
    get: {
      req: AdvisorUsersControllerGetBudgetsData
      res: {
        /**
         * Budgets fetched successfully
         */
        200: BudgetStats
      }
    }
  }
  '/advisors/user/{userId}/goals': {
    get: {
      req: AdvisorUsersControllerGetGoalsData
      res: {
        /**
         * Goals retrieved successfully
         */
        200: Array<GoalData>
      }
    }
  }
  '/advisors/user/{userId}/accounts': {
    get: {
      req: AdvisorUsersControllerGetAccountsData
      res: {
        /**
         * Accounts retrieved successfully
         */
        200: GetAccounts
      }
    }
  }
  '/advisors/user/{userId}/transactions': {
    get: {
      req: AdvisorUsersControllerGetTransactionsData
      res: {
        /**
         * Transactions retrieved successfully
         */
        200: Array<MappedTransaction>
      }
    }
  }
  '/advisors/user/{userId}/goal': {
    post: {
      req: AdvisorGoalsControllerCreateGoalRecommendationData
      res: {
        /**
         * Create a goal recommendation for a user
         */
        201: GoalRecommendationData
      }
    }
  }
  '/advisors/appointments': {
    get: {
      req: AdvisorAppointmentsControllerGetAllAppointmentsData
      res: {
        /**
         * Get all appointments for the advisor
         */
        200: AdvisorAppointmentData
      }
    }
  }
  '/admin/stats/users': {
    get: {
      req: AdminStatsControllerGetUserStatsData
      res: {
        /**
         * Get user stats
         */
        200: UserStatsCounter
      }
    }
  }
  '/admin/stats/gender': {
    get: {
      req: AdminStatsControllerGetGenderStatsData
      res: {
        /**
         * An object where each key is a gender and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/admin/stats/race': {
    get: {
      req: AdminStatsControllerGetRaceStatsData
      res: {
        /**
         * An object where each key is a race and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/admin/stats/age': {
    get: {
      req: AdminStatsControllerGetAgeStatsData
      res: {
        /**
         * An object where each key is an age and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/admin/stats/income': {
    get: {
      req: AdminStatsControllerGetIncomeStatsData
      res: {
        /**
         * An object where each key is an age and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/admin/stats/topics': {
    get: {
      req: AdminStatsControllerGetTopicsStatsData
      res: {
        /**
         * An object where each key is a topic and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/admin/companies': {
    get: {
      res: {
        /**
         * Get all companies
         */
        200: Array<CompanyData>
      }
    }
  }
  '/admin/whitelist/emails': {
    post: {
      req: AdminWhitelistControllerAddWhitelistedEmailsData
      res: {
        /**
         * Number of whitelisted emails added
         */
        201: unknown
      }
    }
    delete: {
      req: AdminWhitelistControllerDeleteWhitelistedEmailsData
      res: {
        /**
         * Number of whitelisted emails removed
         */
        200: unknown
      }
    }
  }
  '/admin/users/verify': {
    put: {
      req: AdminUsersControllerVerifyUserData
      res: {
        /**
         * Returned when user is verified successfully
         */
        200: CommonResponse
        /**
         * Returned when user with given email does not exist
         */
        404: CommonErrorResponse
      }
    }
  }
  '/employer/stats/users': {
    get: {
      req: EmployerStatsControllerGetUserStatsData
      res: {
        /**
         * Get user stats
         */
        200: UserStatsCounter
      }
    }
  }
  '/employer/stats/gender': {
    get: {
      res: {
        /**
         * An object where each key is a gender and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/employer/stats/race': {
    get: {
      res: {
        /**
         * An object where each key is a race and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/employer/stats/age': {
    get: {
      res: {
        /**
         * An object where each key is an age group and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/employer/stats/income': {
    get: {
      res: {
        /**
         * An object where each key is an income group and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/employer/stats/topics': {
    get: {
      res: {
        /**
         * An object where each key is a topic and the value is the count of users
         */
        200: StatsCounter
      }
    }
  }
  '/employer/users': {
    get: {
      res: {
        /**
         * Get all employees
         */
        200: Array<UserData>
      }
    }
  }
  '/employer/user/{userId}': {
    delete: {
      req: EmployerUsersControllerDeleteEmployeeData
      res: {
        /**
         * Delete employee
         */
        204: void
      }
    }
  }
  '/employer/user/{userId}/role': {
    put: {
      req: EmployerUsersControllerChangeRoleData
      res: {
        /**
         * Change company user role
         */
        201: UserData
      }
    }
  }
  '/employer/advisors': {
    get: {
      res: {
        /**
         * Get all advisors
         */
        200: Array<AdvisorData>
      }
    }
  }
  '/insights': {
    get: {
      req: InsightsControllerGetInsightsData
      res: {
        /**
         * Insights for the requested page
         */
        200: InsightsResponse
      }
    }
  }
  '/appointment': {
    post: {
      req: AppointmentsControllerCreateAppointmentData
      res: {
        /**
         * The appointment has been successfully created.
         */
        201: AppointmentData
      }
    }
  }
  '/appointments': {
    get: {
      req: AppointmentsControllerGetAppointmentsData
      res: {
        200: unknown
      }
    }
  }
  '/appointment/webhook/receive': {
    post: {
      res: {
        201: unknown
      }
    }
  }
  '/support/search': {
    get: {
      req: SupportControllerSearchData
      res: {
        /**
         * Search results returned successfully
         */
        200: SupportSearchResponse
      }
    }
  }
  '/support': {
    post: {
      req: SupportControllerCreateTicketData
      res: {
        /**
         * Support ticket sent successfully
         */
        204: void
      }
    }
  }
  '/email-notifications/evaluate': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/email-notifications/dispatch': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/email-notifications/baseline': {
    get: {
      res: {
        200: unknown
      }
    }
  }
  '/email-preview/send': {
    get: {
      req: EmailPreviewControllerSendData
      res: {
        200: unknown
      }
    }
  }
}
